import { omniAtom } from "src/utils/atoms";
import { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";
import type { StudioBlockingState } from "src/pages/CdtStudio/store/blockingMode";
import type { CopilotPendingFix } from "src/components/ConfigCopilot/store/useConfigCopilot";

const prefix = "modals/storePlanogramRules";

export interface StorePlanogramRulesModalStoreProps {
  mode: "store";
  merchflowId: number;
  basePogId: number;
  isBasePogFavorited: boolean;
  storeCodes: string[];
  defaultHighDensityEnabled?: boolean;

  oFix?: CopilotPendingFix;
  /**
   * The base planogram's newest CDT Studio release. With one, the CDT choice
   * defaults to it (CATEGORY_TREE); absent or null means there is none.
   */
  cdtReleaseId?: number | null;
  /**
   * What that release means for the blocking mode. Absent where the opener knows
   * nothing about the studio: the rules keep their own defaults.
   */
  studioBlockingState?: StudioBlockingState;
  /**
   * The flow was started from a CDT version ("Next → Generate"): the CDT
   * choice defaults to Primary / pinned CDT even without a Studio release.
   */
  cdtSourceFromVersion?: boolean;
}

export interface StorePlanogramRulesModalBaseProps {
  mode: "base";
  merchflowId: number;
  s2SolutionId: number;
  pog: PogNonCircular;
}

export type StorePlanogramRulesModalProps =
  | StorePlanogramRulesModalStoreProps
  | StorePlanogramRulesModalBaseProps;

export const storePlanogramRulesDataAtom = omniAtom({
  prefix,
  key: "data",
  value: null as StorePlanogramRulesModalProps | null,
});
